module.exports = __webpack_public_path__ + "e18.no2.2f7e43fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e18.no2.jpg
// module id = ipAY
// module chunks = 0